export default {"src":"/_next/static/image/public/images/language/en.1e64ba6eef328afc45c52397872470a0.svg","height":18,"width":18};